import { useEffect, useState } from 'react';

type ToastKind = 'success' | 'info' | 'error';

interface ToastItem {
  id: number;
  kind: ToastKind;
  message: string;
}

let nextId = 1;
const listeners = new Set<(items: ToastItem[]) => void>();
let items: ToastItem[] = [];

function emit() {
  for (const l of listeners) l(items);
}

export function showToast(message: string, kind: ToastKind = 'success', durationMs = 1800): void {
  const id = nextId++;
  items = [...items, { id, kind, message }];
  emit();
  setTimeout(() => {
    items = items.filter((it) => it.id !== id);
    emit();
  }, durationMs);
}

export function ToastHost() {
  const [list, setList] = useState<ToastItem[]>(items);
  useEffect(() => {
    const fn = (next: ToastItem[]) => setList(next);
    listeners.add(fn);
    return () => {
      listeners.delete(fn);
    };
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        right: 18,
        bottom: 18,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        zIndex: 2000,
        pointerEvents: 'none',
      }}
    >
      {list.map((t) => (
        <div
          key={t.id}
          style={{
            background: 'var(--panel)',
            color: 'var(--text)',
            border: '1px solid var(--panel-border)',
            borderLeft: `3px solid ${colorFor(t.kind)}`,
            borderRadius: 'var(--radius)',
            padding: '10px 14px',
            fontSize: 12,
            fontWeight: 500,
            boxShadow: 'var(--shadow)',
            animation: 'toast-in 0.18s ease-out',
            minWidth: 200,
          }}
        >
          {t.message}
        </div>
      ))}
      <style>{`@keyframes toast-in { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }`}</style>
    </div>
  );
}

function colorFor(kind: ToastKind): string {
  if (kind === 'success') return '#16a34a';
  if (kind === 'error') return '#dc2626';
  return '#2563eb';
}
